import gql from 'graphql-tag';

export const GET_LISTA_CARTERAS = gql(`
   query listadoCarteras($filter: [String], $sort: [String], $page: Int!, $size: Int!) {
      listadoCarteras(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
         totalElements
         firstElement
         results {
            id
            nombre
            descripcion
            referenciaCliente
            operativa
            idPadre
            cliente {
               idLegal
               nombre
               apellidos
            }
            usuarioCliente {
               idLegal
               nombre
               apellidos
            }
            acreedor {
               idLegal
               nombre
               apellidos
            }
            segmento {
                  id
                  nombre
                  activo
            }
            acreedorPorDefecto
            acreedorObligatorio
            iban
            diasLimiteImpagos
            diasLimiteIncidencias
            fechaActualizacion 
         }
      }
   }
`);

export const MODIFICAR_CARTERA = gql(`
    mutation modificarCartera ($idCartera: Long, $modificarCarteraRequest: ModificarCarteraRequestInput) {
      modificarCartera(idCartera: $idCartera, modificarCarteraRequestInput: $modificarCarteraRequest) {
			id
      }
    }
`);
export const ACTUALIZAR_FECHA_CARTERA = gql(`
   mutation ActualizarFecha($idCartera: Long) {
      actualizarFecha(idCartera: $idCartera) {
         id
         fechaActualizacion
      }
   }
`); 